import { ADMIN_MFA_ERROR_CODES } from '@gozoki/api-types/src/validation/adminMfa'
import type { routes } from 'gozoki-backend/registry'
import { frenchDateTime } from '~/lib/iso-date'
import { getApiErrorCode } from '~/lib/utils'

/*
 * Double facteur de l'admin connecté (lot S1.4b) : règles pures des écrans « Sécurité du compte »,
 * du bandeau d'avertissement et de l'enrôlement obligatoire.
 */

/** État rendu par `GET /auth/mfa-admin` : enrôlement, et obligation qui vise le compte. */
export type AdminMfaStatus = (typeof routes)['auth.admin_mfa_status']['types']['response']

/** Avant la date : un compte concerné, pas encore enrôlé, est averti sur chaque page. */
export const showsObligationBanner = ({ enrolled, obligation }: AdminMfaStatus): boolean =>
  obligation.applies && !enrolled && !obligation.enforced && obligation.requiredFrom !== null

/** Refus d'une session que l'obligation contraint, quelle que soit la route appelée. */
export const isMfaEnrollmentRefusal = (error: unknown): boolean =>
  getApiErrorCode(error) === ADMIN_MFA_ERROR_CODES.enrollmentRequired

/** Clé à saisir à la main dans l'application, par groupes de quatre caractères. */
export const groupSecret = (secret: string): string => secret.match(/.{1,4}/g)?.join(' ') ?? secret

/** Fichier texte des codes de secours, téléchargé à l'enrôlement. */
export const recoveryCodesText = (codes: readonly string[], host: string, at: Date): string =>
  [
    `Codes de secours du double facteur — back-office Lucie (${host})`,
    `Générés le ${frenchDateTime(at)}.`,
    'Chaque code ouvre une session une seule fois, sans le téléphone. Gardez-les en lieu sûr.',
    '',
    ...codes,
    '',
  ].join('\n')

export const RECOVERY_CODES_FILE_NAME = 'codes-de-secours-lucie.txt'
